import React from "react";
import List from "../Components/List";
import SidebarLayout from "../Components/sidebar/SidebarLayout";

const MyListing = () => {
  return (
    <>
      <SidebarLayout>
        <div style={{ position: "relative" }}>
          <List />
        </div>
      </SidebarLayout>
    </>
  );
};

export default MyListing;
